import { useContext, useEffect, useState } from "react";

import { auth } from "./firebase";
import Login from "./components/Auth/Login";
import {
  getIdTokenResult,
  onAuthStateChanged,
  ParsedToken,
} from "firebase/auth";

import { AppContext } from "./context/context";
import { payloadTypes } from "./context/reducer";
import SysAdminRoutes from "./Routes";
import AssetRoutes from "./components/modules/asset/Routes";
import QuotationRoutes from "./components/modules/asset/purchase/quotation/login/QuotationLoginRoutes";
import MobileRoutes from "./components/modules/asset/purchase/quotation/login/MobileRoutes";
import PrivacyPolicy from "./components/PrivacyPolicy";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
const AssetManagement = () => {
  const [claims, setClaims] = useState<ParsedToken | null>(null);
  const { state, dispatch } = useContext(AppContext);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        dispatch({ type: payloadTypes.SET_USER, payload: { user } });
        getIdTokenResult(user).then((IdTokenResult) => {
          const { claims } = IdTokenResult;

          dispatch({
            type: payloadTypes.SET_CLAIMS,
            payload: { claims },
          });
          setClaims(claims);
        });
      }
    });
  }, [dispatch]);

  return (
    <div className="h100">
      <Router>
        <Routes>
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        </Routes>
      </Router>
      {state.claims ? (
        <>{state.claims.EDUATE ? <SysAdminRoutes /> : <AssetRoutes />}</>
      ) : (
        <>
          {window.location.pathname.includes("/vendor/") ? (
            <QuotationRoutes />
          ) : window.location.pathname.includes("/astram") ? (
            <MobileRoutes />
          ) : window.location.pathname.includes("/privacypolicy") ? null : (
            <Router>
              <Routes>
                <Route path="/" element={<Login />} />
              </Routes>
            </Router>
          )}
        </>
      )}
    </div>
  );
};

export default AssetManagement;
